import { useState } from "react";
import { useProductFruitsApi } from "react-product-fruits";

import useProcessEvent from "@hooks/useProcessEvent";
import { useUIStore } from "@stores";

import { ONBOARDING_CHECKLIST_ID } from "@components/ProductFruits/constants";
import { EVENTS } from "@constants/processEvents";

import { hasCompletedTheChecklist } from "@components/ProductFruits/helpers/checklistHelper";
import { Checklist, ProductFruitsApi } from "@components/ProductFruits/types";

export const useOnboardingChecklist = (): { checklistData: Checklist | null } => {
  const [checklistData, setChecklistData] = useState<Checklist | null>(null);

  const { setShowProductFruitsChecklist } = useUIStore((state) => state);

  const { handleProcessEvent } = useProcessEvent();

  const refreshChecklistData = (api: ProductFruitsApi): void => {
    const checklists = api.checklists.getChecklists();

    const checklist = checklists.find((checklist) => checklist.id === ONBOARDING_CHECKLIST_ID);

    if (!checklist) {
      setChecklistData(null);
      return;
    }

    if (hasCompletedTheChecklist(checklist)) {
      handleProcessEvent(EVENTS.COMPLETE_ONBOARDING);
      setChecklistData(null);
      return;
    }

    setChecklistData(checklist);
  };

  useProductFruitsApi((api: ProductFruitsApi) => {
    refreshChecklistData(api);

    const handleItemCompleted = (): void => {
      refreshChecklistData(api);
    };

    const handleDismissed = (checklistId: number): void => {
      if (checklistId !== ONBOARDING_CHECKLIST_ID) return;

      setShowProductFruitsChecklist(false);
      setChecklistData(null);
    };

    api.checklists.listen("item-completed", handleItemCompleted);
    api.checklists.listen("dismissed", handleDismissed);
  }, []);

  return { checklistData };
};
